module.exports = __webpack_public_path__ + "img/Mayowa Agunloye_Data Analyst.22b55b97.jpg";